import React from 'react';

export default function TinySwordSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      {/* Blade */}
      <path d="M20 2L24 28L20 30L16 28Z" fill="#B0BEC5" />
      {/* Blade edge shine */}
      <path d="M20 4L22 26" stroke="white" strokeWidth="1" opacity="0.4" />
      {/* Blade tip */}
      <path d="M18 26L20 2L22 26" stroke="#78909C" strokeWidth="0.5" fill="none" />
      {/* Guard */}
      <rect x="10" y="28" width="20" height="3" rx="1.5" fill="#FFB300" />
      {/* Grip */}
      <rect x="18" y="31" width="4" height="6" rx="1" fill="#5D4037" />
      <path d="M18 33H22M18 35H22" stroke="#4E342E" strokeWidth="0.5" />
      {/* Pommel */}
      <circle cx="20" cy="38" r="2" fill="#FFB300" />
    </svg>
  );
}
